import React, { Component } from "react";
import '../css/table-responsive.css'
import '../css/dashboard.css'
import { AuthContext } from "../services/auth/authContext";
import { getValueCookie } from "../services/cookieService";
import TableSalesTypeView from "../components/TableofSalesType/TableSalesTypeView";
import { getCurrentBalance, getCustomerExcess, getCustomerHistory, getSalesByCustomer, getSalesOrdersPerUser, 
  getSalesPerMonth, getSalesPerRoute, getSalesPerSalesPerson, getShorts, getAltitudeInvReceipts } from "./InitialDashBoard/Functions";
import TableofPendingSalesView from "../components/TableofPendingSales/TableofPendingSalesView";
import TableofExcessCustomerView from "../components/TableofExcessCustomer/TableofExcessCustomerView";
import TableofCurrentBalanceView from "../components/TableofCurrentBalance/TableofCurrentBalanceView";
import { MonthInLetters, NameSalesPerson, NumberFormat } from "../functions/generalFunctions";
import CalendarOfSales from "../components/CalendarOfSales/CalendarOfSales";
import TableHistoryCustomerView from "../components/TableHistoryCustomer/TableHistoryCustomerView";
import TableDetailSalesPerRouteView from "../components/TableDetailSalesPerRoute/TableDetailSalesPerRouteView";
import TableShortView from "../components/TableShort/TableShortView";
import { getIndexElement } from "../functions/searchInObject";
import LoadingWindow from "../components/LoadingWindow";
import TableSalesPerSalesPersonView from "../components/TableofSalesPerSalesPerson/TableSalesPerSalesPersonView";
import BarSalesDasboard from "../components/BarSalesDashboard/BarSalesDasboard";
import DashTotalsView from "../components/DashTotalsView/DashTotalsView";
import { getInformationWithDataDashboard as getInformationWithData } from '../services/CABE.js'
import { FaChartBar } from 'react-icons/fa';
import { AiOutlineFileSearch } from "react-icons/ai";

// Menu
import { Menu } from "../components/Menu/Menu";

export default class AdminLobbyV2 extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();
  }

  state = {
    data: [],
    altitudePaidInv: [],
    altitudePaidInvFiltered: [],
    altitudeStartYearFilter: new Date( new Date().getFullYear(), 0,1),
    altitudeEndYearFilter: new Date(),
    altitudeStartDateFilter: (() => {
      const now = new Date();
      const dayOfWeek = now.getDay(); // 0 = Sunday, 1 = Monday
      const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // If Sunday, go back 6 days
      const monday = new Date(now);
      monday.setDate(now.getDate() + diff);
      return monday;
    })(),
    altitudeEndDateFilter: new Date()
  }

  componentDidMount() {
    this.getMultipleInfo();
  }

  getInfo(SalesPerson) {
    let button = document.getElementById('LobbyInfoCharge' + SalesPerson)
    if (button) {
      button.click();
    }
  }

  // Get and set sales persons data V2
  async getMultipleInfo() {
    const company = getValueCookie('CompanyId');
    var data = [];
    var now = new Date();
    // Loating modal
    this.ModalLoading.current.showState(true);

    // Get sales person by company - V2
    const salesPeople = await getInformationWithData('/v2/company/dashboardSalesperson', {companyId: company});

    if (salesPeople && salesPeople.data && Array.isArray(salesPeople.data)) {
      const salesPersonList = Array.from(
        new Set(
          salesPeople.data
          .map(function (u) { return u.salesPerson; })
          .filter(function (sp) { return sp != null && sp !== ""; })
        )
      );

      // Admins (TypeUser 1 or 12) always get a synthetic "Totals" tab
      const typeUser = getValueCookie('TypeUser');
      if ((typeUser === '1' || typeUser === '12') && !salesPersonList.includes('TOT')) {
        salesPersonList.push('TOT');
      }

      // Get sales persons from cookie
      // const salesPersonList = getValueCookie("SalesPersonList"); <------- V1
  
      for (var i = 0; i < salesPersonList.length; i++) {
        var SalesPerson = salesPersonList[i];
  
        var temporal = {
          Load: i !== 0, // el primero cargado, el resto marcados como "Load: true" como antes
  
          SalesPerRouteDate: now,
          SalesPerSalesPersonDate: now,
  
          SalesPerRoute: { Information: [], Months: [] },
          SalesPerSalesPersons: { Information: [], Months: [] },
          CustomerHistory: [],
          PendingSalesOrders: [],
          CustomerExcess: [],
          CurrentBalance: [],
          SalesPerson: SalesPerson,
          SalesByCustomer: [],
          SalesPerMonth: [],
          RouteYearSales: [],
          Shorts: {},
  
          Totals: {
            TotalPendingInvoices: {
              TotalDueInv: 0,
              Range1: 0,
              Range2: 0,
              Range3: 0,
              TotalR1: 0,
              TotalR2: 0,
              TotalR3: 0
            },
            SalesOrder: {
              NotStarted: 0,
              InProcess: 0,
              Finished: 0
            },
            Customer: {
              Normal: 0,
              Frequent: 0,
              Waring: 0,
              Risk: 0,
              Total: 0
            },
            Sales: {
              NoInvoices: 0,
              Total: 0
            }
          }
        };
  
        data.push(temporal);
      }
  
      // Tab order: Andrea (AM), Rafael (RR), Altitude (0000), Corporativo (0010), Totals (TOT)
      const TAB_ORDER = ['AM', 'RR', '0000', '0010', 'TOT'];
      data.sort((a, b) => {
        const ai = TAB_ORDER.indexOf(a.SalesPerson);
        const bi = TAB_ORDER.indexOf(b.SalesPerson);
        return (ai === -1 ? TAB_ORDER.length : ai) - (bi === -1 ? TAB_ORDER.length : bi);
      });

      // Seteamos el estado una sola vez y luego disparamos la carga del primero
      this.setState({ data: data }, function () {
        // Hide loading
        this.ModalLoading.current.showState(false);
  
        // Load data for the first tab — use sorted data[0], not salesPersonList[0] (pre-sort order)
        if (data && data.length > 0) {
          this.getSpecificInfo(true, data[0].SalesPerson);
        }
      }.bind(this));
    }

  }

  // New load center V2
  async getSpecificInfo(flag, SalesPerson) {
    if (!flag) return;

    const index = getIndexElement(this.state.data, 'SalesPerson', SalesPerson);
    if (index === -1) return;

    // Marcar todas las secciones de ese SalesPerson como cargando
    var data = this.state.data.slice();
    var current = data[index];

    data[index] = {
      ...current,
      SalesPerRouteLoading: true,
      SalesPerRouteError: null,
      PendingSalesOrderLoading: true,
      PendingSalesOrderError: null,
      CustomerExcessLoading: true,
      CustomerExcessError: null,
      CurrentBalanceLoading: true,
      CurrentBalanceError: null,
      CustomerHistoryLoading: true,
      CustomerHistoryError: null,
      SalesByCustomerLoading: true,
      SalesByCustomerError: null,
      SalesPerMonthLoading: true,
      SalesPerMonthError: null,
      SalesPerSalesPersonsLoading: true,
      SalesPerSalesPersonsError: null,
      ShortsLoading: true,
      ShortsError: null
    };
    this.setState({ data });

    // Disparar cargas en paralelo (Sin await para hacer carga individual)
    this.loadSalesPerRoute(SalesPerson, index);
    this.loadPendingSalesOrder(SalesPerson, index);
    this.loadCustomerExcess(SalesPerson, index);
    this.loadCurrentBalance(SalesPerson, index);
    this.loadCustomerHistory(SalesPerson, index);
    this.loadSalesByCustomer(SalesPerson, index);
    this.loadSalesPerMonth(SalesPerson, index);
    this.loadSalesPerSalesPersons(SalesPerson, index);
    this.loadShorts(SalesPerson, index);

    // FIX: Asignar un reload en paralelo
    if (SalesPerson === '0000') {
      const start = this.state.altitudeStartYearFilter.toISOString();
      const end = this.state.altitudeEndYearFilter.toISOString();
      const { altitudeStartDateFilter, altitudeEndDateFilter } = this.state;
      const paidInvoices = await getAltitudeInvReceipts(start, end);
      const weekFilter = paidInvoices.data.filter((inv) => {
        const invDate = inv.InvoiceDate
        return invDate >= altitudeStartDateFilter && invDate <= altitudeEndDateFilter
      })
      
      this.setState({altitudePaidInv: paidInvoices.data, altitudePaidInvFiltered: weekFilter});
    }
  }

  // Load sales per route individualy V2
  async loadSalesPerRoute(SalesPerson, index) {
    try {
      const SalesPerRoute = await getSalesPerRoute(SalesPerson);

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        data[index] = {
          ...current,
          SalesPerRoute: SalesPerRoute,
          SalesPerRouteDate: new Date(),
          SalesPerRouteLoading: false,
          SalesPerRouteError: null
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          SalesPerRouteLoading: false,
          SalesPerRouteError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }


  // Loading pending sales individualy V2
  async loadPendingSalesOrder(SalesPerson, index) {
    // Set date
    var dataStart = this.state.data.slice();
    var currentStart = dataStart[index];

    dataStart[index] = {
      ...currentStart
    };
    this.setState({ data: dataStart });

    try {
      const PendingSalesOrder = await getSalesOrdersPerUser(SalesPerson);

      var NotStarted = 0;
      var InProcess = 0;
      var Finished = 0;

      for (var i = 0; i < PendingSalesOrder.length; i++) {
        var SalesOrder = PendingSalesOrder[i];

        SalesOrder.Status = SalesOrder.Status ? SalesOrder.Status : 0;

        const amt = Number(SalesOrder.NonTaxableAmt) || 0;
        switch (SalesOrder.Status) {
          case 0:  NotStarted += amt; break;
          case 1:  InProcess  += amt; break;
          case 2:  Finished   += amt; break;
          default: break;
        }
      }

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        const currentTotals = current.Totals || {
          TotalPendingInvoices: { TotalDueInv: 0, Range1: 0, Range2: 0, Range3: 0, TotalR1: 0, TotalR2: 0, TotalR3: 0 },
          SalesOrder: { NotStarted: 0, InProcess: 0, Finished: 0 },
          Customer: { Normal: 0, Frequent: 0, Waring: 0, Risk: 0, Total: 0 },
          Sales: { NoInvoices: 0, Total: 0 }
        };
        data[index] = {
          ...current,
          PendingSalesOrders: PendingSalesOrder,
          PendingSalesOrderLoading: false,
          PendingSalesOrderError: null,
          Totals: { ...currentTotals, SalesOrder: { NotStarted, InProcess, Finished } }
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          PendingSalesOrderLoading: false,
          PendingSalesOrderError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }

  // Loading customer excess individualy V2
  async loadCustomerExcess(SalesPerson, index) {
    try {
      const CustomerExcess = await getCustomerExcess(SalesPerson);

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        data[index] = {
          ...current,
          CustomerExcess: CustomerExcess,
          CustomerExcessLoading: false,
          CustomerExcessError: null
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          CustomerExcessLoading: false,
          CustomerExcessError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }

  // Loading customer history individualy V2
  async loadCustomerHistory(SalesPerson, index) {
    try {
      const CustomerHistory = await getCustomerHistory(SalesPerson);

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        data[index] = {
          ...current,
          CustomerHistory: CustomerHistory,
          CustomerHistoryLoading: false,
          CustomerHistoryError: null
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          CustomerHistoryLoading: false,
          CustomerHistoryError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }

  // Loading sales by customer individualy V2
  async loadSalesByCustomer(SalesPerson, index) {
    try {
      const SalesByCustomer = await getSalesByCustomer(SalesPerson, null);

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        data[index] = {
          ...current,
          SalesByCustomer: SalesByCustomer,
          SalesByCustomerLoading: false,
          SalesByCustomerError: null
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          SalesByCustomerLoading: false,
          SalesByCustomerError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }

  // Load sales by month
  async loadSalesPerMonth(SalesPerson, index) {
    try {
      // Totals
      let TotSales = {
        NoInvoices: 0,
        Total: 0
      };

      const SalesPerMonth = await getSalesPerMonth(SalesPerson, null);

      // Get totals from API result (before setState)
      for (const Sale of SalesPerMonth) {
        if (Sale.Week) {
          TotSales.NoInvoices += Number(Sale.totalsales)
          TotSales.Total += Number(Sale.total)
        }
      }

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        data[index] = {
          ...current,
          SalesPerMonth: SalesPerMonth,
          SalesPerMonthLoading: false,
          SalesPerMonthError: null,
          NoInvoices: TotSales.NoInvoices,
          Total: TotSales.Total,
          Totals: {
            ...current.Totals,
            Sales: TotSales
          }
        };
        return { data };
      });
      // Update calendar
      this.asignTotalsCalendar(SalesPerMonth, SalesPerson);
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          SalesPerMonthLoading: false,
          SalesPerMonthError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }


  // Loading sales by sales person V2
  async loadSalesPerSalesPersons(SalesPerson, index) {
    try {
      const SalesPerSalesPersons = await getSalesPerSalesPerson(SalesPerson, null);

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        data[index] = {
          ...current,
          SalesPerSalesPersons: SalesPerSalesPersons,
          SalesPerSalesPersonsLoading: false,
          SalesPerSalesPersonsError: null
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          SalesPerSalesPersonsLoading: false,
          SalesPerSalesPersonsError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }


  // Loading shorts V2
  async loadShorts(SalesPerson, index) {
    try {
      const Shorts = await getShorts(SalesPerson, null);

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        data[index] = {
          ...current,
          Shorts: Shorts,
          ShortsLoading: false,
          ShortsError: null
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          ShortsLoading: false,
          ShortsError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }


  // Loading balance individualy V2
  async loadCurrentBalance(SalesPerson, index) {
    try {
      const CurrentBalance = await getCurrentBalance(SalesPerson);

      var TotalPendingInvoices = {
        TotalDueInv: 0,
        Range1: 0,
        Range2: 0,
        Range3: 0,
        TotalR1: 0,
        TotalR2: 0,
        TotalR3: 0
      };

      for (var i = 0; i < CurrentBalance.length; i++) {
        var Invoice = CurrentBalance[i];
        var balance = Invoice.Balance || 0;
        var days = Number(Invoice.DaysDlq);

        if (balance > 0) {
          TotalPendingInvoices.TotalDueInv += balance;
        }

        if (days <= 14) {
          TotalPendingInvoices.Range1 += 1;
          if (balance > 0) {
            TotalPendingInvoices.TotalR1 += balance;
          }
        } else if (days >= 15 && days <= 29) {
          TotalPendingInvoices.Range2 += 1;
          if (balance > 0) {
            TotalPendingInvoices.TotalR2 += balance;
          }
        } else {
          TotalPendingInvoices.Range3 += 1;
          if (balance > 0) {
            TotalPendingInvoices.TotalR3 += balance;
          }
        }
      }

      this.setState(prevState => {
        const data = prevState.data.slice();
        const current = data[index];
        const currentTotals = current.Totals || {
          TotalPendingInvoices: { TotalDueInv: 0, Range1: 0, Range2: 0, Range3: 0, TotalR1: 0, TotalR2: 0, TotalR3: 0 },
          SalesOrder: { NotStarted: 0, InProcess: 0, Finished: 0 },
          Customer: { Normal: 0, Frequent: 0, Waring: 0, Risk: 0, Total: 0 },
          Sales: { NoInvoices: 0, Total: 0 }
        };
        data[index] = {
          ...current,
          CurrentBalance: CurrentBalance,
          CurrentBalanceLoading: false,
          CurrentBalanceError: null,
          Totals: { ...currentTotals, TotalPendingInvoices }
        };
        return { data };
      });
    } catch (e) {
      this.setState(prevState => {
        const dataError = prevState.data.slice();
        const currentError = dataError[index];
        dataError[index] = {
          ...currentError,
          CurrentBalanceLoading: false,
          CurrentBalanceError: 'Can not get data from the API. '
        };
        return { data: dataError };
      });
    }
  }


  async changeMonthSalesPerRoute(SalesPerson, DateC) {
    this.ModalLoading.current.showState(true);
    const index = await getIndexElement(this.state.data, 'SalesPerson', SalesPerson)
    const SalesPerRoute = await getSalesPerRoute(SalesPerson, new Date(DateC))
    const SalesByCustomer = await getSalesByCustomer(SalesPerson, new Date(DateC))
    if (index !== -1) {
      this.setState(prevState => {
        const data = prevState.data.slice()
        data[index] = { ...data[index], SalesPerRouteMonth: DateC, SalesPerRoute, SalesByCustomer }
        return { data }
      })
    }
    this.ModalLoading.current.showState(false);
  }

  async changeMonthSalesPerSalesPerson(SalesPerson, DateC) {
    this.ModalLoading.current.showState(true);
    const index = await getIndexElement(this.state.data, 'SalesPerson', SalesPerson)
    const SalesPerSalesPersons = await getSalesPerSalesPerson(SalesPerson, new Date(DateC))
    if (index !== -1) {
      this.setState(prevState => {
        const data = prevState.data.slice()
        data[index] = { ...data[index], SalesPerRouteMonth: DateC, SalesPerSalesPersons }
        return { data }
      })
    }
    this.ModalLoading.current.showState(false);
  }

  async changeDateSalesPerMonth(SalesPerson, DateC) {
    this.ModalLoading.current.showState(true);
    const index = await getIndexElement(this.state.data, 'SalesPerson', SalesPerson)
    const SalesPerMonth = await getSalesPerMonth(SalesPerson, new Date(DateC))
    if (index !== -1) {
      let TotSales = { NoInvoices: 0, Total: 0 }
      for (const Sale of SalesPerMonth) {
        if (Sale.Week) {
          TotSales.NoInvoices += Number(Sale.totalsales)
          TotSales.Total += Number(Sale.total)
        }
      }
      this.setState(prevState => {
        const data = prevState.data.slice()
        const prev = data[index]
        data[index] = {
          ...prev,
          SalesPerRouteDate: new Date(DateC),
          SalesPerMonth,
          Totals: { ...prev.Totals, Sales: TotSales }
        }
        return { data }
      })
      this.asignTotalsCalendar(SalesPerMonth, SalesPerson)
    }
    this.ModalLoading.current.showState(false);
  }

  async changeAllMonthData(SalesPerson, DateC) {
    await this.changeMonthSalesPerRoute(SalesPerson, DateC)
    await this.changeDateSalesPerMonth(SalesPerson, DateC)
    if (SalesPerson === 'TOT') {
      await this.changeMonthSalesPerSalesPerson(SalesPerson, DateC)
    }
  }


  asignTotalsCalendar(Data, SalesPerson) {
    for (const week of Data) {

      if (week.Week) {

        let m = document.getElementById('quant_' + week.Week + "_" + SalesPerson)
        let n = document.getElementById('sales_' + week.Week + "_" + SalesPerson)
        if (m) {
          m.innerHTML = NumberFormat(Number(Number(week.totalsales).toFixed(0)))
        }
        if (n) {
          n.innerHTML = "$" + NumberFormat(Number(Number(week.total).toFixed(0)))

        }
      }
    }
  }

  applyFilters = () => {
    this.ModalLoading.current.showState(true);
    const { altitudeStartDateFilter, altitudeEndDateFilter, altitudePaidInv } = this.state;

    const filtered = altitudePaidInv.filter((inv) => {
      const invDate = new Date(inv.InvoiceDate);
      return invDate >= altitudeStartDateFilter && invDate <= altitudeEndDateFilter;
    })

    this.setState({ altitudePaidInvFiltered: filtered});
    this.ModalLoading.current.showState(false);
  }

handleAltitudeStartDate = (e) => {
  this.setState({ altitudeStartDateFilter: new Date(e.target.value) });
}

handleAltitudeEndDate = (e) => {
  this.setState({ altitudeEndDateFilter: new Date(e.target.value) });
}


  render() {
    const labelStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: '5px' };
    const inputStyle = { borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem', padding: '0.4rem 0.75rem', width: '100%' };
    const {altitudePaidInvFiltered, altitudeStartDateFilter, altitudeEndDateFilter} = this.state
    
    return (
      <div className="dash-page">
        <div id="GeneralPages" className="page container-fluid" style={{paddingTop: '50px'}}>
          {/* Main menu */}
          <Menu Refresh={this.state.Refresh} Father={this} />

          {/* Loading modal */}
          <LoadingWindow ref={this.ModalLoading} />

          {getValueCookie('TypeUser') === '1' || getValueCookie('TypeUser') === '12' ?
            <div className='col-sm-12'>
              <ul className="nav nav-tabs" id="ScanningControls" role="tablist">
                {this.state.data.map((element, e) => (
                  <li key={e} hidden={false} className="nav-item" role="presentation">
                    {element.SalesPerson === 'TOT' ? (
                      <button
                        onClick={() => this.getSpecificInfo(element.Load, element.SalesPerson)}
                        id={'DashBoardFromSP' + element.SalesPerson}
                        className={e === 0 ? "nav-link active" : "nav-link"}
                        data-bs-toggle="tab"
                        data-bs-target={"#DashSP" + element.SalesPerson}
                        type="button"
                        role="tab"
                        style={{
                          background: 'linear-gradient(135deg, #2563EB 0%, #8b5cf6 100%)',
                          color: 'white',
                          borderRadius: '8px 8px 0 0',
                          fontWeight: 700,
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.4rem',
                          border: 'none',
                          padding: '0.5rem 1.1rem',
                        }}
                      >
                        <FaChartBar />
                        Totals
                      </button>
                    ) : (
                      <button
                        onClick={() => this.getSpecificInfo(element.Load, element.SalesPerson)}
                        id={'DashBoardFromSP' + element.SalesPerson}
                        className={e === 0 ? "nav-link active" : "nav-link"}
                        data-bs-toggle="tab"
                        data-bs-target={"#DashSP" + element.SalesPerson}
                        type="button"
                        role="tab"
                        aria-controls="DashBoardSP"
                        aria-selected="true"
                        style={{ color: e === 0 ? '#0f2342' : '#4c4c4cff' }}
                      >
                        {NameSalesPerson(element.SalesPerson)}
                      </button>
                    )}
                  </li>
                ))}
              </ul>

              <div className="tab-content" id="allDashActive">
                {this.state.data.map((element, e) => (
                  <div key={e} className={e === 0 ? "tab-pane fade show active" : "tab-pane fade show"} id={"DashSP" + element.SalesPerson} role="tabpanel" aria-labelledby="">
                    {element.SalesPerson === 'TOT' ? (
                      <DashTotalsView element={element} Father={this} />
                    ) : (
                    <div className="row g-4" style={{ paddingTop: '1.5rem', paddingBottom: '2rem' }}>
                      {
                        false ?
                          <React.Fragment>
                            <div className="col-sm-6">
                              <div className="col-12 pt-2 pb-3">
                                <TableSalesTypeView
                                  SalesPerson={element.SalesPerson}
                                  Father={this}
                                  Date={element.SalesPerRouteDate}
                                  Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()}
                                  Title={"Sales by Distribution Channel"}
                                  data={element.SalesPerRoute}
                                  loading={element.SalesPerRouteLoading}
                                  error={element.SalesPerRouteError}
                                  key='SalesbyDistributionChannel' 
                                  showMonths
                                />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div hidden={element.SalesPerson !== "TOT"} className="col-12 pt-2 pb-3">
                                <TableSalesPerSalesPersonView SalesPerson={element.SalesPerson} Father={this} Date={element.SalesPerRouteDate} Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()} Title={"Sales by Sales Person"} data={element.SalesPerSalesPersons} />
                              </div>
                            </div>
                            <div className="col-12">
                              <BarSalesDasboard Title="Graphs of Sales" Data={element.RouteYearSales} />
                            </div>
                            <div className="col-sm-6">

                              <div className="col-12 pt-2 pb-3">
                                <TableDetailSalesPerRouteView Title={"Sales by Customer"} data={element.SalesByCustomer} />
                              </div>
                              <div className="col-12 pt-2 pb-3">
                                <CalendarOfSales Father={this} Totals={element.Totals.Sales} Date={element.SalesPerRouteDate} SalesPerson={element.SalesPerson} data={element.SalesPerMonth} Title={"Sales Per Day"} />
                              </div>
                              {element.SalesPerson !== "TOT" ?
                                <div className="col-12 pt-2 pb-3">
                                  <TableShortView SalesPerson={element.SalesPerson} data={element.Shorts} Title={"Shorts of Last 15 Days"} />
                                </div>
                                :
                                <></>}
                            </div>

                            <div className="col-sm-6">
                              <div className="row">

                                <div className="col-sm-12">

                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableofCurrentBalanceView
                                        Title={"Past Due Invoices"}
                                        Totals={element.Totals.TotalPendingInvoices}
                                        data={element.CurrentBalance}
                                        loading={element.CurrentBalanceLoading}
                                        error={element.CurrentBalanceError}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-12">

                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableofExcessCustomerView
                                        Title={"Customers with Exceeded Credit Limit"}
                                        data={element.CustomerExcess}
                                        loading={element.CustomerExcessLoading}
                                        error={element.CustomerExcessError}
                                      />
                                    </div>
                                  </div>


                                </div>
                                {element.SalesPerson !== "TOT" ?
                                  <div className="col-sm-12">

                                    <div className="row">
                                      <div className="col-12 pt-2 pb-3">
                                        <TableofPendingSalesView
                                          Title={"Actual Sales Order"}
                                          Totals={element.Totals.SalesOrder}
                                          data={element.PendingSalesOrders}
                                          loading={element.PendingSalesOrderLoading}
                                          error={element.PendingSalesOrderError}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  : <></>}

                                <div className="col-sm-12">

                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableHistoryCustomerView 
                                        Title={"Days of Last Sale"} 
                                        Totals={element.Totals.Customer} 
                                        data={element.CustomerHistory} 
                                      />
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            <div className="col-sm-12">
                              {getValueCookie('TypeUser') === "1" && element.SalesPerson === '0000' && (
                                <div className="col-12 pt-2 pb-3">
                                  {/* Business cards */}
                                  {/* <div className="col-12 pt-2 pb-3 row d-flex justify-content-center">
                                    <div className="col-md-3 d-flex justify-content-center">
                                      <label className="form-label">
                                        Start Date:
                                        
                                      </label>
                                    </div>
                                    <div className="col-md-3 d-flex justify-content-center">
                                      <label className="form-label">
                                        End Date:
                                        
                                      </label>
                                    </div>
                                    <div className="col-md-2 align-content-center">
                                      <button className="btn greenButtonv2 w-50" onClick={this.applyFilters}>Apply</button>
                                    </div>
                                  </div> */}

                                  <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                                        <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Date Range</span>
                                    </div>
                                    <div className="card-body">
                                      <div className="row g-3 align-items-end">
                                        <div className="col-sm-12 col-md-3">
                                          <label style={labelStyle} htmlFor="startSalesFilterDate">Start Date</label>
                                          <input className="form-control" type="date" value={altitudeStartDateFilter.toISOString().split('T')[0]} onChange={this.handleAltitudeStartDate} />
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                          <label style={labelStyle} htmlFor="endSalesFilterDate">End Date</label>
                                          <input className="form-control" type="date" value={altitudeEndDateFilter.toISOString().split('T')[0]} onChange={this.handleAltitudeEndDate} />
                                        </div>
                                        <div className="col-sm-12 col-md-3">
                                          <button onClick={this.applyFilters} style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center' }}>
                                              <AiOutlineFileSearch /> Apply
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* TODO: Crear un componente para estas cards */}
                                  {/* Mayaland cards */}
                                  <div className="col-12 row pt-2 pb-3">
                                    <h3 className="mb-4"><span className="badge rounded-pill text-bg-primary">Mayaland</span></h3>
                                    <div className="col-6">
                                      <h6 className='card-title-clean mb-4'>Selected period</h6>
                                      <div className="row mb-3">
                                        <div className="col-6">
                                          <div className='metric-card status-danger'>
                                              <p className='metric-label'>Invoices issued</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInvFiltered.filter((inv) => inv.MyInvoice).length}
                                              </div>
                                              <div className='metric-change'>To Altitude</div>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className='metric-card status-success'>
                                              <p className='metric-label'>Paid Invoices</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInvFiltered.filter((inv) => inv.MyInvoicePaid).length}
                                              </div>
                                              <div className='metric-change'>Received payments</div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-primary'>
                                              <p className='metric-label'>Total Revenue</p>
                                              <div className='metric-value'>
                                                  {this.state.altitudePaidInvFiltered.filter((inv) => inv.MyInvoicePaid).reduce((accumulator, object) => {return accumulator + Number(object.Total);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                              <div className='metric-change'>From Altitude</div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-warning'>
                                              <p className='metric-label'>Pending Amount</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInvFiltered.filter((inv) => !inv.MyInvoicePaid).reduce((accumulator, object) => {return accumulator + Number(object.Total);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                              <div className='metric-change'>Awaiting payment</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <h6 className='card-title-clean mb-4'>Year {new Date().getFullYear()} period</h6>
                                      <div className="row mb-3">
                                        <div className="col-6">
                                          <div className='metric-card status-danger'>
                                              <p className='metric-label'>Invoices issued</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInv.filter((inv) => inv.MyInvoice).length}
                                              </div>
                                              <div className='metric-change'>To Altitude</div>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className='metric-card status-success'>
                                              <p className='metric-label'>Paid Invoices</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInv.filter((inv) => inv.MyInvoicePaid).length}
                                              </div>
                                              <div className='metric-change'>Received payments</div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-primary'>
                                              <p className='metric-label'>Total Revenue</p>
                                              <div className='metric-value'>
                                                  {this.state.altitudePaidInv.filter((inv) => {
                                                    const invDate = new Date(inv.MyInvoicePaidDate);
                                                    return inv.MyInvoicePaid && invDate >= this.state.altitudeStartYearFilter && invDate <= this.state.altitudeEndYearFilter
                                                  }).reduce((accumulator, object) => {return accumulator + Number(object.MyInvoiceTotal);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                              <div className='metric-change'>From Altitude</div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-warning'>
                                              <p className='metric-label'>Pending Amount</p>
                                              <div className='metric-value'>
                                                  {this.state.altitudePaidInv.filter((inv) => {
                                                    const invDate = new Date(inv.MyInvoiceDate);
                                                    return !inv.MyInvoicePaid && invDate >= this.state.altitudeStartYearFilter && invDate <= this.state.altitudeEndYearFilter
                                                  }).reduce((accumulator, object) => {return accumulator + Number(object.MyInvoiceTotal);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                              <div className='metric-change'>Awaiting payment</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <hr/>

                                  {/* Altitude cards */}
                                  <div className="col-12 row pt-2 pb-3">
                                    <h3 className="mb-4"><span className="badge rounded-pill text-bg-secondary">Altitude</span></h3>
                                    <div className="col-6">
                                      <h6 className='card-title-clean mb-4'>Selected period</h6>
                                      <div className="row mb-3">
                                        <div className="col-6">
                                          <div className='metric-card status-danger'>
                                              <p className='metric-label'>Invoices issued</p>
                                              <div className='metric-value'>
                                                {altitudePaidInvFiltered.length}
                                              </div>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className='metric-card status-success'>
                                              <p className='metric-label'>Paid Invoices</p>
                                              <div className='metric-value'>
                                                {altitudePaidInvFiltered.filter((inv) => inv.Paid).length}
                                              </div>
                                              <div className='metric-change'>Received payments</div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-primary'>
                                              <p className='metric-label'>Total Revenue</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInvFiltered.filter((inv) => inv.MyInvoicePaid).reduce((accumulator, object) => {return accumulator + Number(object.MyInvoiceTotal);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-warning'>
                                              <p className='metric-label'>Pending Amount</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInvFiltered.filter((inv) => !inv.MyInvoicePaid).reduce((accumulator, object) => {return accumulator + Number(object.MyInvoiceTotal);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                              <div className='metric-change'>Awaiting payment</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <h6 className='card-title-clean mb-4'>Year 2026 period</h6>
                                      <div className="row mb-3">
                                        <div className="col-6">
                                          <div className='metric-card status-danger'>
                                              <p className='metric-label'>Invoices issued</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInv.length}
                                              </div>
                                          </div>
                                        </div>
                                        <div className="col-6">
                                          <div className='metric-card status-success'>
                                              <p className='metric-label'>Paid Invoices</p>
                                              <div className='metric-value'>
                                                {this.state.altitudePaidInv.filter((inv) => inv.Paid).length}
                                              </div>
                                              <div className='metric-change'>Received payments</div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-primary'>
                                              <p className='metric-label'>Total Revenue</p>
                                              <div className='metric-value'>
                                                  {this.state.altitudePaidInv.filter((inv) => {
                                                    const invDate = new Date(inv.InvoiceDate);
                                                    return inv.Paid && this.state.altitudeStartYearFilter && invDate <= this.state.altitudeEndYearFilter
                                                  }).reduce((accumulator, object) => {return accumulator + Number(object.Total);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                          </div>
                                        </div>
                                        <div className="col-6" style={{marginTop: '10px'}}>
                                          <div className='metric-card status-warning'>
                                              <p className='metric-label'>Pending Amount</p>
                                              <div className='metric-value'>
                                                  {this.state.altitudePaidInv.filter((inv) => {
                                                    const invDate = new Date(inv.InvoiceDate);
                                                    return !inv.paid && invDate >= this.state.altitudeStartYearFilter && invDate <= this.state.altitudeEndYearFilter
                                                  }).reduce((accumulator, object) => {return accumulator + Number(object.Total);}, 0).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}
                                              </div>
                                              <div className='metric-change'>Awaiting payment</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* All transaction table */}
                                  <div className="col-12 pt-2 pb-3">
                                    <div className='col-12'>
                                      <div className='card'>
                                        <div className='card-body'>
                                          <div className='row'>
                                            <div className='col-sm-6'>
                                              <h6 className='card-title-clean mb-0'>Altitude & Mayaland Invoices</h6>
                                            </div>
                                            <div className='backgroundWhite col-sm-12 '>
                                              <div className='pb-3' />
                                              <div className="tableFixHeadSmall">
                                                <table className='table table-clean'>
                                                    <thead>
                                                      <tr>
                                                        <th>Order No</th>
                                                        <th>Customer No</th>
                                                        <th>Customer Name</th>
                                                        <th>Date</th>
                                                        <th>Total</th>
                                                        <th>Status</th>
                                                        <th>Paid Date</th>
                                                        <th>Mayaland Inv</th>
                                                        <th>Mayaland Total</th>
                                                        <th>Mayaland Status</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.altitudePaidInv.map((order, o) => (
                                                        <tr key={o}>
                                                          <td>{order.InvoiceNo}</td>
                                                          <td>{order.CustomerNo}</td>
                                                          <td>{order.CustomerName}</td>
                                                          <td>{new Date(order.InvoiceDate).toISOString().slice(0, 10)}</td>
                                                          <td>${order.Total}</td>
                                                          <td className='text-center'>
                                                            {order.Paid?
                                                            <span className="dash-status-pill status-success">Paid</span>
                                                            : <span className="dash-status-pill status-warning">Pending</span>}
                                                          </td>
                                                          <td className='text-center'>{order.PaidDate? order.PaidDate : ''}</td>
                                                          <td>{order.MyInvoice}</td>
                                                          <td>{order.MyInvoiceTotal? `$${order.MyInvoiceTotal}`:''}</td>
                                                          <td className='text-center'>
                                                            {order.MyInvoicePaid? 
                                                            <span className="dash-status-pill status-success">Paid</span>
                                                            : <span className="dash-status-pill status-warning">Pending</span>}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-sm-6">
                              <div className="col-12 pt-2 pb-3">
                                <TableSalesTypeView
                                  SalesPerson={element.SalesPerson}
                                  Father={this} Date={element.SalesPerRouteDate}
                                  Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()}
                                  Title={"Sales by Distribution Channel"}
                                  data={element.SalesPerRoute}
                                  loading={element.SalesPerRouteLoading}
                                  error={element.SalesPerRouteError}
                                  key='SalesbyDistributionChannel' 
                                  showMonths 
                                />
                              </div>
                              <div className="col-12 pt-2 pb-3">
                                <TableDetailSalesPerRouteView Title={"Sales by Customer"} data={element.SalesByCustomer} />
                              </div>
                              <div className="col-12 pt-2 pb-3">
                                <CalendarOfSales 
                                  Father={this} 
                                  Totals={element.Totals.Sales} 
                                  Date={element.SalesPerRouteDate} 
                                  SalesPerson={element.SalesPerson} 
                                  data={element.SalesPerMonth} 
                                  Title={"Sales Per Day"} 
                                />
                              </div>
                              {element.SalesPerson !== "TOT" ?
                                <div className="col-12 pt-2 pb-3">
                                  <TableShortView SalesPerson={element.SalesPerson} data={element.Shorts} Title={"Shorts of Last 15 Days"} />
                                </div>
                                :
                                <></>}

                            </div>
                            <div className="col-sm-6">
                              <div className="row">
                                <div hidden={element.SalesPerson !== "TOT"} className="col-12 pt-2 pb-3">
                                  <TableSalesPerSalesPersonView SalesPerson={element.SalesPerson} Father={this} Date={element.SalesPerRouteDate} Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()} Title={"Sales by Sales Person"} data={element.SalesPerSalesPersons} />
                                </div>

                                <div className="col-sm-12">
                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableofCurrentBalanceView
                                        Title={"Past Due Invoices"}
                                        Totals={element.Totals.TotalPendingInvoices}
                                        data={element.CurrentBalance}
                                        loading={element.CurrentBalanceLoading}
                                        error={element.CurrentBalanceError}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-12">
                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableofExcessCustomerView
                                        Title={"Customers with Exceeded Credit Limit"}
                                        data={element.CustomerExcess}
                                        loading={element.CustomerExcessLoading}
                                        error={element.CustomerExcessError}
                                      />
                                    </div>
                                  </div>
                                </div>

                                {element.SalesPerson !== "TOT" ?
                                  <div className="col-sm-12">

                                    <div className="row">
                                      <div className="col-12 pt-2 pb-3">
                                        <TableofPendingSalesView
                                          Title={"Actual Sales Order Totals"}
                                          Totals={element.Totals.SalesOrder}
                                          data={element.PendingSalesOrders}
                                          loading={element.PendingSalesOrderLoading}
                                          error={element.PendingSalesOrderError}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  : <></>}

                                <div className="col-sm-12">

                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableHistoryCustomerView 
                                        Title={"Days of Last Sale"} 
                                        Totals={element.Totals.Customer} 
                                        data={element.CustomerHistory} 
                                      />
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </React.Fragment>
                      }
                    </div>
                  )}
                  </div>
                ))}

                </div>
              </div>
            : null}

        </div>
      </div>
    )
  }
}
